import clsx from 'clsx'
import { formatMoney } from '../../../helpers/currency-formatter'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
}

export function Price({ price, compareAtPrice, className }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'

  const formatPrice = (value: string) => {
    if (!value) return ''

    const priceInCents = Math.round(parseFloat(value) * 100)

    return formatMoney(priceInCents, moneyFormat)
  }

  return (
    <p className={clsx(className)}>
      <span className={clsx('paragraph-s font-bold', isOnSale ? 'text-brand-sale' : '')}>
        {formatPrice(price)}
      </span>
      {!isOnSale ? null : (
        <span className="line-through paragraph-s">
          {formatPrice(compareAtPrice || '')}
        </span>
      )}
    </p>
  )
}
